import { config } from "./config";

export const SITE_DISPLAY_NAME = config.siteName;
export const SITE_URL = config.siteUrl;
export const SITE_PRODUCT_NAME = `${config.siteName} Public API`;
export const ORGANIZATION_DESCRIPTION = config.siteDescription;
export const SUPPORT_EMAIL = config.supportEmail;
